import type { SelectOption } from "@circle-react-shared/BuilderUI/PropsMetaUnits.types";
import { Form } from "@circle-react-uikit/Form";
import { useFormItem } from "../../DefaultEditorV2/useFormItem";
import { FormSegmentedControl } from "@/react/components/shared/uikit/Form/FormSegmentedControl";

export interface WrapFieldProps {
  label: string;
  name: string;
  options: SelectOption[] | ReadonlyArray<SelectOption>;
}

const ICONS = {
  wrap: "16-wrap",
  nowrap: "16-nowrap",
  "wrap-reverse": "16-wrap-reverse",
};

const WRAP_ORDER = ["wrap", "nowrap", "wrap-reverse"] as const;

export const WrapField = ({ name, label, options }: WrapFieldProps) => {
  const { getFormItemProps } = useFormItem();
  const optionsMap = new Map(options.map(opt => [opt.value, opt]));

  const formattedOptions = WRAP_ORDER.map(value => optionsMap.get(value))
    .filter(
      (option): option is SelectOption =>
        option !== undefined && option.value in ICONS,
    )
    .map(option => ({
      icon: ICONS[option.value as keyof typeof ICONS],
      iconSize: 16,
      label: ICONS[option.value as keyof typeof ICONS] ? null : option.label,
      value: option.value,
      contentWrapperClassName: "justify-center",
      iconWrapperClassName: "flex items-center",
    }));

  return (
    <Form.Item name={name} label={label} {...getFormItemProps()}>
      <FormSegmentedControl options={formattedOptions} name={name} />
    </Form.Item>
  );
};
